export enum PaymentStatus {
        SUCCESS = 1,
        CANCEL = 2,
        FAIL = 3,
        INITIATED = 4,
        CHECK_SERVER = 5
}
